import React from "react";
import { Modal, Typography } from "antd";

const { Text } = Typography;

export function BannerModal(props) {
  const { subtitle, children, ...modalProps } = props;

  return (
    <Modal {...modalProps}>
      <Text style={{ display: "block", marginBottom: "16px" }}>{subtitle}</Text>
      {children}
    </Modal>
  );
}
